export const FETCH_MORE_RESULT_HISTORY_SAGA = 'FETCH_MORE_RESULT_HISTORY_SAGA';
export const SHOW_RESULT_HISTORY_SAGA = 'SHOW_RESULT_HISTORY_SAGA';

export const APPEND_RESULT_HISTORY_LIST = 'APPEND_RESULT_HISTORY_LIST';
export const ADD_RESULT_HISTORY = 'ADD_RESULT_HISTORY';
export const SET_LOADING_STATE = 'SET_LOADING_STATE';
export const SET_END_STATE = 'SET_END_STATE';

export const fetchMoreResultHistoryAction = () => ({
  type: FETCH_MORE_RESULT_HISTORY_SAGA,
});

export const showResultHistoryAction = ({ id, replaceHistory = false }) => ({
  type: SHOW_RESULT_HISTORY_SAGA,
  id,
  replaceHistory
});

export const appendResultHistoryListAction = results => ({
  type: APPEND_RESULT_HISTORY_LIST,
  results,
});

export const addResultHistoryAction = result => ({
  type: ADD_RESULT_HISTORY,
  result
});

export const setLoadingState = loading => ({
  type: SET_LOADING_STATE,
  loading,
});

export const setEndState = end => ({
  type: SET_END_STATE,
  end,
});



// WEBPACK FOOTER //
// ./src/actions/result-history.js